import { ClickToDialViewMode } from "@/Common/Components/CallCenter/ClickToDial.types";
import { ClickToDialView } from "@/Common/Components/CallCenter/ClickToDialView";
import { ElementWithIcon } from "@/Common/Components/ElementWithIcon";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { Guid } from "@/Common/Models/Guid";
import { ConsentProgramHistory } from "@/Common/Models/Patient/ConsentProgramHistory";
import { IPatientOtherInformationModel } from "@/Common/Models/Patient/UI/Profile/IPatientOtherInformationModel";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { InvalidPharmacyWarningMessage } from "@/ContactDirectory/Components/Common/InvalidPharmacyWarningMessage";
import { PreferredPharmacyHelper } from "@/ContactDirectory/Helpers/PreferredPharmacyHelper";
import { LegacyPatientConsentPrograms } from "@/Patient/Components/Consent/LegacyPatientConsentPrograms";
import { PatientConsentPrograms } from "./ConsentComponents/PatientConsentPrograms";
import { IPatientProfileOtherProps } from "./OtherEdit";

class OtherViewFixed extends React.Component<IPatientProfileOtherProps, any> {
    private readonly mexicoCountryLookup = cacheStore.FindLookupByLookupCode("CNMEXICO").LookupID;
    private preferredPharmacyHelper: PreferredPharmacyHelper;

    constructor(props: IPatientProfileOtherProps) {
        super(props);
        this.preferredPharmacyHelper = new PreferredPharmacyHelper(
            patientStore.PatientModels[props.model.get("PatientContactId")]?.Addresses,
            sessionStore.getCurrentEmployee()
        );
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        const model: IPatientOtherInformationModel = this.props.model ?? null;
        const isMexico = this.props.PatientCountryId == this.mexicoCountryLookup;
        const pharmacyInfo = model.get("PreferredPharmacy")?.getPharmacyInfo(true, this.preferredPharmacyHelper);

        const consentProgramHistory = model
            .get("ConsentProgramHistory")
            ?.toArray()
            .map(dto => new ConsentProgramHistory(model.get("PatientContactId"), dto)).toImmutable()
            ?? [].toImmutable();

        return (
            <div className="patient-prof" data-cy="otherView">
                <div className="scrollable" style={{ maxHeight: "669px", minHeight: "669px" }}>
                    <div className="block separated">
                        <div className="flex-container heading">
                            <h3 className="h thin-font">{cacheStore.GetString("PreferredPharmacyLabel")}</h3>
                        </div>

                        <div className="psingle-column centered">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1"><label className="form-label">{cacheStore.GetString("PharmacyNameLabel")}</label></td>
                                        <td className="c2">
                                            <ElementWithIcon includeIcon={cacheStore.validateMylePharmacy(!!pharmacyInfo?.IsMylePharmacy)}>
                                                <strong>{MyleHelper.ReplaceEmptyString(pharmacyInfo?.Banner)}</strong>
                                            </ElementWithIcon>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="c1"><label className="form-label">{cacheStore.GetString("PharmacistsLabel")}</label></td>
                                        <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(pharmacyInfo?.Name)}</strong></td>
                                    </tr>

                                    <tr>
                                        <td className="c1"><label className="form-label">{cacheStore.GetString("PhoneLabel")}</label></td>
                                        <td className="c2"><strong>{this.renderPhoneElement(pharmacyInfo?.Phone, GuidHelper.AsGuid(model.get("PatientContactFacetId")))}</strong></td>
                                    </tr>

                                    <tr>
                                        <td className="c1"><label className="form-label">{cacheStore.GetString("FaxLabel")}</label></td>
                                        <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(pharmacyInfo?.Fax)}</strong></td>
                                    </tr>

                                    <tr>
                                        <td className="c1"><label className="form-label">{cacheStore.GetString("AddressLabel")}</label></td>
                                        <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(pharmacyInfo?.Address)}</strong></td>
                                    </tr>
                                    {model.get("PreferredPharmacy")?.getDirectoryPharmacy()?.isInvalid && (
                                        <tr>
                                            <td className="c1" />
                                            <td className="c2"><InvalidPharmacyWarningMessage /></td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="block separated">
                        <div className="flex-container heading">
                            <h3 className="h thin-font">{cacheStore.GetString("InsuranceCompanyLabel")}</h3>
                        </div>

                        <div className="psingle-column centered">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1"><label className="form-label">{cacheStore.GetString("InsuranceCompanyNameLabel")}</label></td>
                                        <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(model.get("InsuranceCompanyName"))}</strong></td>
                                    </tr>
                                    {!isMexico && (
                                        <tr>
                                            <td className="c1"><label className="form-label">{cacheStore.GetString("PolicyNoLabel")}</label></td>
                                            <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(model.get("InsurancePolicyNo"))}</strong></td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="block separated">
                        <div className="flex-container heading">
                            <h3 className="thin-font">{cacheStore.GetString("ConsentProgramLabel")}</h3>
                            <div
                                onClick={e => sessionStore.dispatch(cacheStore.ClinicSettings.EnableConsentProgramHistory ? LocalPatientOperations.Profile.OtherInfo_AddConsentProgramDialog : LocalPatientOperations.Profile.OtherInfo_AddConsentPopup, e)}
                                style={{ paddingTop: "10px", paddingRight: "20px" }}
                            >
                                <a>{"[+] " + cacheStore.GetString("AddConsentProgramLabel")}</a>
                            </div>
                        </div>

                        {!cacheStore.ClinicSettings.EnableConsentProgramHistory && (
                            <LegacyPatientConsentPrograms
                                items={model.get("PatientConsentsList")}
                                readOnly
                            />
                        )}

                        {cacheStore.ClinicSettings.EnableConsentProgramHistory && (
                            <PatientConsentPrograms
                                patientContactId={model.get("PatientContactId")}
                                items={consentProgramHistory}
                                readOnly
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }

    private renderPhoneElement(phoneNumber: string | null, patientContactFacetId: Guid): JSX.Element {
        if (cacheStore.ClinicSettings.IsCallCenterEnabled() && phoneNumber) {
            return (
                <ClickToDialView
                    viewMode={ClickToDialViewMode.Hyperlink}
                    formattedPhoneNumber={phoneNumber}
                    patientContactFacetId={patientContactFacetId}
                />
            );
        }

        return (
            <>{MyleHelper.ReplaceEmptyString(phoneNumber)}</>
        );
    }
}

export { OtherViewFixed };
